<rid-compare
  (finished)="$router.navigate(['/mechanics/formule'])"
  [questions]="[
    { id: '1', options: ['5', '3', '7', '4'], answer: 2 },
    { id: '2', options: ['1', '4', '8', '2'], answer: 2 },
    { id: '3', options: ['5', '1', '4', '3'], answer: 0 },
    { id: '4', options: ['6', '3', '1', '7'], answer: 3 },
    { id: '5', options: ['3', '1', '2', '5 + 3'], answer: 3 },
  ]"
  class="h-dvh"
/>
